import { ArchiveType, isPersonalPageArchiveType, PersonalPageArchiveType } from '../../archive-type';
import { isPersonalPageSubtype } from './guards';
import type { ArchiveCreationFlow, PersonalPageFamily, PersonalPageSubtype } from './types';

/** Read subtype from archive template: personalPageType holds subtype; archiveType holds family */
export function parseArchivePersonalPageType(
  personalPageType?: string,
  archiveType?: string
): PersonalPageSubtype | undefined {
  if (isPersonalPageSubtype(personalPageType)) {
    return personalPageType;
  }
  if (personalPageType === 'registration') {
    return 'serviceRegistration';
  }
  if (personalPageType === 'event') {
    return 'choiceEvent';
  }
  if (archiveType === ArchiveType.donationsArchive) {
    return 'choiceDonation';
  }
  if (archiveType === ArchiveType.eventsArchive) {
    return 'choiceEvent';
  }
  if (archiveType === ArchiveType.informationPagesArchive) {
    return 'fixedFormLead';
  }
  return undefined;
}

const ARCHIVE_TYPE_TO_FAMILY: Record<PersonalPageArchiveType, PersonalPageFamily> = {
  [ArchiveType.donationsArchive]: 'campaign',
  [ArchiveType.eventsArchive]: 'event',
  [ArchiveType.informationPagesArchive]: 'information'
};

export function getFamilyFromArchiveType(archiveType?: string): PersonalPageFamily | undefined {
  return isPersonalPageArchiveType(archiveType) ? ARCHIVE_TYPE_TO_FAMILY[archiveType] : undefined;
}

export function resolveArchiveCreationFlow(archiveType: string): ArchiveCreationFlow {
  const family = getFamilyFromArchiveType(archiveType);

  if (family === 'campaign') {
    return 'campaign';
  }
  if (family === 'information') {
    return 'information';
  }
  return 'event';
}
